var keys = {
    TMP_name: "TMP_name",
    TMP_cat: "TMP_cat",
    TMP_preview: "TMP_preview",
    TMP_lang: "TMP_lang",
    TMP_tooltipAddLang: "TMP_tooltipAddLang",
    TMP_tooltipCopy: "TMP_tooltipCopy",
    TMP_addTemplateButtonLabel: "TMP_addTemplateButtonLabel",
    TMP_emptyStateTitle: "TMP_emptyStateTitle",
    TMP_emptyStateHelptext: "TMP_emptyStateHelptext",
    TMP_cardHeader: "TMP_cardHeader",
    TMP_namePlaceholder: "TMP_namePlaceholder",
    TMP_nameLabel: "TMP_nameLabel",
    TMP_cat1: "TMP_cat1",
    TMP_cat2: "TMP_cat2",
    TMP_cat3: "TMP_cat3",
    TMP_cat4: "TMP_cat4",
    TMP_cat5: "TMP_cat5",
    TMP_cat6: "TMP_cat6",
    TMP_cat7: "TMP_cat7",
    TMP_cat8: "TMP_cat8",
    TMP_cat9: "TMP_cat9",
    TMP_cat10: "TMP_cat10",
    TMP_cat11: "TMP_cat11",
    TMP_langLabel: "TMP_langLabel",
    TMP_typeLabel: "TMP_typeLabel",
    TMP_type1: "TMP_type1",
    TMP_type2: "TMP_type2",
    TMP_bodyPlaceholder: "TMP_bodyPlaceholder",
    TMP_blocksHelptext: "TMP_blocksHelptext",
    TMP_header: "TMP_header",
    TMP_body: "TMP_body",
    TMP_footer: "TMP_footer",
    TMP_button: "TMP_button",
    TMP_buttons: "TMP_buttons",
    TMP_chars: "TMP_chars",
    TMP_vars: "TMP_vars",
    TMP_headerMedia1: "TMP_headerMedia1",
    TMP_headerMedia2: "TMP_headerMedia2",
    TMP_headerMedia3: "TMP_headerMedia3",
    TMP_headerMedia4: "TMP_headerMedia4",
    TMP_headerMedia5: "TMP_headerMedia5",
    TMP_footerPlaceholder: "TMP_footerPlaceholder",
    TMP_headerPlaceholder: "TMP_headerPlaceholder",
    TMP_quickReply: "TMP_quickReply",
    TMP_cta: "TMP_cta",
    TMP_phoneNumber: "TMP_phoneNumber",
    TMP_url: "TMP_url",
    TMP_addButtonLabel: "TMP_addButtonLabel",
    TMP_discardButtonLabel: "TMP_discardButtonLabel",
    TMP_previewButtonLabel: "TMP_previewButtonLabel",
    TMP_buttonLabelPlaceholder: "TMP_buttonLabelPlaceholder",
    TMP_buttonVarHelpText: "TMP_buttonVarHelpText",
    TMP_previewHeader1: "TMP_previewHeader1",
    TMP_previewHeader2: "TMP_previewHeader2",
    TMP_exampleValues: "TMP_exampleValues",
    TMP_varEmptyStateHelptext1: "TMP_varEmptyStateHelptext1",
    TMP_varEmptyStateHelptext2: "TMP_varEmptyStateHelptext2",
    TMP_varEmptyStateHelptext3: "TMP_varEmptyStateHelptext3",
    TMP_docsLinkLabel: "TMP_docsLinkLabel",
    TMP_saveSuccess: "TMP_saveSuccess",
    TMP_namePatternError: "TMP_namePatternError",
    TMP_backToList: "TMP_backToList",
    TMP_backToEditor: "TMP_backToEditor",
    TMP_submit: "TMP_submit",
    TMP_headerImgPlaceholder: "TMP_headerImgPlaceholder",
    TMP_buttonUrlVarPlaceholder: "TMP_buttonUrlVarPlaceholder",
    TMP_headerDocumentPlaceholder: "TMP_headerDocumentPlaceholder",
    TMP_tooltipDelete: "TMP_tooltipDelete",
    TMP_deleteAllButtonLabel: "TMP_deleteAllButtonLabel",
    TMP_deleteConfirmText: "TMP_deleteConfirmText",
    TMP_deleteAllConfirmButtonLabel: "TMP_deleteAllConfirmButtonLabel",
    TMP_deleteAllSuccess: "TMP_deleteAllSuccess",
    TMP_deleteSingleSuccess: "TMP_deleteSingleSuccess",
    TMP_buttonsCounter: "TMP_buttonsCounter",
    TMP_pleaseNote: "TMP_pleaseNote",
    TMP_helperBulletText1: "TMP_helperBulletText1",
    TMP_helperBulletText2: "TMP_helperBulletText2",
    TMP_helperBulletText3: "TMP_helperBulletText3",
    TMP_helperBulletText4: "TMP_helperBulletText4",
    TMP_sampleValueInfoText: "TMP_sampleValueInfoText",
    TMP_missingExamplesError: "TMP_missingExamplesError",
    TMP_buttonPreviewHelptext: "TMP_buttonPreviewHelptext",
    TMP_syncTemplates: "TMP_syncTemplates",
    TMP_successSyncTemplates: "TMP_successSyncTemplates",
    TMP_syncDone: "TMP_syncDone",
    TMP_justNow: "TMP_justNow",
    TMP_lastSync: "TMP_lastSync",
    TMP_headerVideoPlaceholder: "TMP_headerVideoPlaceholder",
    TMP_errorInvalidUrl: "TMP_errorInvalidUrl",
    TMP_nameProposal: "TMP_nameProposal",
    TMP_status: "TMP_status",
    TMP_balance: "TMP_balance",
    TMP_autoRenewalStatus: "TMP_autoRenewalStatus",
    TMP_autoRenewalThreshold: "TMP_autoRenewalThreshold",
    TMP_autoRenewalAmount: "TMP_autoRenewalAmount",
    TMP_addFunds: "TMP_addFunds",
    TMP_editAutoRenewalAmount: "TMP_editAutoRenewalAmount",
    TMP_editAutoRenewalThreshold: "TMP_editAutoRenewalThreshold",
    TMP_errorInvalidCharacter: "TMP_errorInvalidCharacter",
    TMP_errorVideoExtensions: "TMP_errorVideoExtensions",
    TMP_errorImageExtensions: "TMP_errorImageExtensions",
    TMP_buttonAddVariable: "TMP_buttonAddVariable",
    TMP_newLineFooterWarning: "TMP_newLineFooterWarning",
    TMP_emojiWarning: "TMP_emojiWarning",
    TMP_searchPlaceholder: "TMP_searchPlaceholder",
    TMP_cat12: "TMP_cat12",
    TMP_cat13: "TMP_cat13",
    TMP_cat14: "TMP_cat14",
    TMP_cat15: "TMP_cat15",
    TMP_cat16: "TMP_cat16",
    TMP_tooltipReplicate: "TMP_tooltipReplicate",
    TMP_tooltipAddLangToTemplate: "TMP_tooltipAddLangToTemplate",
    TMP_tooltipEditTemplate: "TMP_tooltipEditTemplate",
    TMP_tooltiMetaSync: "TMP_tooltiMetaSync",
    TMP_ditFieldDisabled: "TMP_ditFieldDisabled",
    TMP_editSuccess: "TMP_editSuccess",
    TMP_editFieldDisabled: "TMP_editFieldDisabled",
    TMP_sampleRequiredValueInfoText: "TMP_sampleRequiredValueInfoText",
    TMP_improperTemplateVariableConfig: "TMP_improperTemplateVariableConfig",
    TMP_metaSync: "TMP_metaSync",
    TMP_invalidPhoneNumber: "TMP_invalidPhoneNumber",
    TMP_categoryTooltip_1: "TMP_categoryTooltip_1",
    TMP_categoryTooltip_2: "TMP_categoryTooltip_2",
    TMP_categoryTooltip_3: "TMP_categoryTooltip_3",
    TMP_allowCategoryChange: "TMP_allowCategoryChange",
    TMP_categoryRejectionTooltip_1a: "TMP_categoryRejectionTooltip_1a",
    TMP_categoryRejectionTooltip_1b: "TMP_categoryRejectionTooltip_1b",
    TMP_categoryRejectionTooltip_2_embedded: "TMP_categoryRejectionTooltip_2_embedded",
    TMP_categoryRejectionTooltip_2_classic: "TMP_categoryRejectionTooltip_2_classic",
    TMP_categoryRejectionTooltip_3: "TMP_categoryRejectionTooltip_3",
    TMP_categoryUpdatedTooltip_1: "TMP_categoryUpdatedTooltip_1",
    TMP_categoryUpdatedTooltip_2: "TMP_categoryUpdatedTooltip_2",
    TMP_categoryUpdatedTooltip_3: "TMP_categoryUpdatedTooltip_3",
    TMP_categoryUpdatedTooltip_4: "TMP_categoryUpdatedTooltip_4",
    TMP_categoryUpdatedTooltip_5: "TMP_categoryUpdatedTooltip_5",
    TMP_categoryUpdatedTooltip_6: "TMP_categoryUpdatedTooltip_6",
    TMP_categoryUpdatedTooltip_7: "TMP_categoryUpdatedTooltip_7",
    TMP_allowCategoryChangeTooltip_1: "TMP_allowCategoryChangeTooltip_1",
    TMP_allowCategoryChangeTooltip_2: "TMP_allowCategoryChangeTooltip_2",
    TMP_headerLocationPlaceholder: "TMP_headerLocationPlaceholder",
    TMP_timeIndicatorTooltip: "TMP_timeIndicatorTooltip",
    TMP_securityDisclaimer: "TMP_securityDisclaimer",
    TMP_expirationWarning: "TMP_expirationWarning",
    TMP_timeIndicator: "TMP_timeIndicator",
    TMP_timeIndicatorErrorMessage: "TMP_timeIndicatorErrorMessage",
    TMP_copyCodeTooltipText: "TMP_copyCodeTooltipText",
    TMP_copyCode: "TMP_copyCode",
    TMP_oneTapTooltipText: "TMP_oneTapTooltipText",
    TMP_copyCodeBtnName: "TMP_copyCodeBtnName",
    TMP_oneTapButtonName: "TMP_oneTapButtonName",
    TMP_appPackageName: "TMP_appPackageName",
    TMP_signatureHash: "TMP_signatureHash",
    TMP_autofill: "TMP_autofill",
    TMP_addAButtonLabel: "TMP_addAButtonLabel",
    TMP_copyCodePlaceholderTooltip: "TMP_copyCodePlaceholderTooltip",
    TMP_appsPackagePlaceholderTooltip: "TMP_appsPackagePlaceholderTooltip",
    TMP_signatureHashPlaceholderTooltip: "TMP_signatureHashPlaceholderTooltip",
    TMP_textCopiedToClipboard: "TMP_textCopiedToClipboard",
    TMP_seeAllOptions: "TMP_seeAllOptions",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,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